var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.7199V8.11987V8.11659C20 6.99867 20 6.43937 19.7822 6.01196C19.5905 5.63564 19.2841 5.32966 18.9078 5.13791C18.48 4.91992 17.9203 4.91992 16.8002 4.91992H5.2002C4.08009 4.91992 3.51962 4.91992 3.0918 5.13791C2.71547 5.32966 2.40973 5.63564 2.21799 6.01196C2 6.43979 2 6.99977 2 8.11987V15.7199C2 16.84 2 17.4001 2.21799 17.828C2.40973 18.2043 2.71547 18.5102 3.0918 18.7019C3.51962 18.9199 4.08009 18.9199 5.2002 18.9199H16.8002C17.9203 18.9199 18.48 18.9199 18.9078 18.7019C19.2841 18.5102 19.5905 18.2043 19.7822 17.828C20 17.4005 20 16.8411 20 15.7232V15.7199Z",
    fill: "url(#paint0_linear_3389_8609)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0332 8.94727L11.1704 13.4223L16.9667 8.94727",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3389_8609",
    x1: 5.75,
    y1: 16.0033,
    x2: 15.8377,
    y2: 5.32218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d89d826c1c6b50fe84af4706cffb272b.svg";
export { ForwardRef as ReactComponent };